import '@resources/fontes/fontes.css'
import { WHATSAPP_NUMBER, WHATSAPP_DISPLAY } from '@constants/contact'
import '@resources/css/contact.css'
import React, { useContext, useState } from 'react'
import Header from '@components/Header/Header'
import Sidebar from '@components/Sidebar/Sidebar'
import LoadingSpinner from '@components/LoadingSpinner/LoadingSpinner'
import '@resources/css/homeuser.css'
import { FaHeart } from 'react-icons/fa'
import Select from 'react-select'
import makeAnimated from 'react-select/animated'
import { BsChevronRight } from 'react-icons/bs'
import { Link } from 'react-router-dom'
import { FaWhatsapp } from 'react-icons/fa6'
import { MdOutlinePhone } from 'react-icons/md'
import AuthContext from '@contexts/Auth'
import { sendContact } from '@services/Contact'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Mask from '@helpers/Mask'

const animatedComponents = makeAnimated()
const SweetAlert = withReactContent(Swal)

const options = [
  { value: '1. Não tenho clínica, por onde começo?', label: '1. Não tenho clínica, por onde começo?' },
  { value: '2. Já tenho o doador escolhido - quero reservar', label: '2. Já tenho o doador escolhido - quero reservar' },
  { value: '3. Tive um bebê com sêmen de doador', label: '3. Tive um bebê com sêmen de doador' },
  { value: '4. Doadores americanos e europeus', label: '4. Doadores americanos e europeus' },
  { value: '5. Outros assuntos', label: '5. Outros assuntos' },
]

const Contact: React.FC<any> = () => {
  const { user } = useContext(AuthContext)
  const [subject, setSubject] = useState<any>(null)
  const [message, setMessage] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubjectChange = (selectedOption: any) => {
    setSubject(selectedOption)
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    SweetAlert.fire({
      title: 'Aguarde...',
      text: 'Enviando mensagem',
      icon: 'info',
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      didOpen: () => SweetAlert.showLoading(),
    })

    setIsSubmitting(true)

    try {
      const formData = new FormData()
      formData.append('name', user?.name || '')
      formData.append('email', user?.email || '')
      formData.append('whatsapp', user?.whatsapp ? Mask.cellphoneView(user?.whatsapp) : '')
      formData.append('subject', subject?.value || '')
      formData.append('message', message)

      await sendContact(formData)

      SweetAlert.fire({
        title: 'Sucesso!',
        text: 'Mensagem enviada com sucesso! Em breve entraremos em contato.',
        icon: 'success',
        confirmButtonText: 'Ok',
      })

      setSubject(null)
      setMessage('')
    } catch (error: any) {
      console.error('Error sending contact form:', error)

      let errorMessage = 'Erro ao enviar mensagem. Por favor, tente novamente.'

      if (error.response && error.response.data && error.response.data.errors) {
        const errors = error.response.data.errors
        const firstError = Object.values(errors)[0]
        if (Array.isArray(firstError) && firstError.length > 0) {
          errorMessage = firstError[0]
        }
      } else if (error.response && error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message
      }

      SweetAlert.fire({
        title: 'Erro!',
        text: errorMessage,
        icon: 'error',
        confirmButtonText: 'Ok',
      })
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="contact d-lg-flex justify-content-lg-center">
      <Sidebar />
      <main className="with-fixed-nav">
        <LoadingSpinner isLoading={isSubmitting} text="Enviando mensagem..." />
        <Header showSidebarOpenButton />
        <div className="row mt-4">
          <div className="col-auto pr-0">
            <Link to="/" className="text-body d-flex align-items-center">Catálogo</Link>
          </div>
          <div className="col-auto pl-1 pr-1">
            <BsChevronRight size={10} />
          </div>
          <div className="col-auto p-0">
            <a href="#" className="id d-flex align-items-center font-weight-bold">
              Contato
            </a>
          </div>
        </div>
        <section className="bg-white rounded-30 shadow-sm p-4 p-lg-5 contact-section my-5">
          <div className="row">
            <div className="col-12 col-sm-6 col-md-7">
              <div className="left">
                <div className="title">
                  <h1>Precisando falar com o Pro-Seed?</h1>
                  <p>É um prazer ter você com a gente! Conte com nosso atendimento personalizado e especializado por WhatsApp, entre em contato por telefone ou envie uma mensagem pelo formulário ao lado. </p>
                </div>
                <div className="d-flex w-100 contact-cards my-4">
                  <a href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent('Olá, gostaria de tirar uma dúvida.')}`} target="_blank" className="contact-card" rel="noreferrer">
                    <div className="contact-card-icon">
                      <FaWhatsapp />
                    </div>
                    <div className="contact-card-info">
                      <span className="contact-card-label">WhatsApp</span>
                      <strong>{WHATSAPP_DISPLAY}</strong>
                    </div>
                  </a>
                  <a href="tel:1131911196" target="_blank" className="contact-card" rel="noreferrer">
                    <div className="contact-card-icon">
                      <MdOutlinePhone />
                    </div>
                    <div className="contact-card-info">
                      <span className="contact-card-label">Telefone</span>
                      <strong>(11) 3171-1196</strong>
                    </div>
                  </a>
                </div>
                <div className="support mb-3 mb-lg-0">
                  <p>Estamos aqui para te apoiar e facilitar a sua jornada! <span><FaHeart /></span></p>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-5">
              <div className="right">
                <form className="box" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <div className="text-box mb-2">
                      <p className="mb-0">Nome</p>
                    </div>
                    <input
                      className="form-control"
                      type="text"
                      value={user?.name}
                      readOnly
                      required
                    />
                  </div>
                  <div className="form-group">
                    <div className="text-box mb-2">
                      <p className="mb-0">Whatsapp</p>
                    </div>
                    <input
                      className="form-control"
                      type="text"
                      value={user?.whatsapp ? Mask.cellphoneView(user?.whatsapp) : ''}
                      readOnly
                      required
                    />
                  </div>
                  <div className="form-group">
                    <div className="text-box mb-2">
                      <p className="mb-0">Assunto <span>*</span></p>
                    </div>
                    <Select
                      className="react-select teste"
                      placeholder={<div>Assunto</div>}
                      components={animatedComponents}
                      options={options}
                      isClearable={true}
                      isSearchable={true}
                      isDisabled={isSubmitting}
                      isLoading={false}
                      isRtl={false}
                      closeMenuOnSelect={true}
                      value={subject}
                      onChange={handleSubjectChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <div className="text-box mb-2">
                      <p className="mb-0">Deixe sua mensagem ou dúvida abaixo:</p>
                    </div>
                    <textarea
                      className="form-control"
                      placeholder="Qual sua mensagem?"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      disabled={isSubmitting}
                      rows={4}
                      required
                    />
                  </div>
                  <div className="btn-group">
                    <button
                      type="submit"
                      className="btn btn-primary btn-block"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? 'Enviando...' : 'Enviar'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  )
}

export default Contact
